import React from "react";
import { PropTypes } from "prop-types";
import { MrbPreviewPage } from "mrb/components/layout";
import { PremiumContentList, SubscriptionPlanCard, DeviceLimitInfoModal } from "application/payment/components";
import { observer } from "mobx-react";
import { defaultTemplate } from "common/hoc";
import { subscriptionPlans as subscriptionPlansConstant } from "common/constants";
import { map } from "lodash";

function PremiumSubscriptionsTemplate({ premiumSubscriptionsViewStore, t }) {
    return (
        <MrbPreviewPage t={t} store={premiumSubscriptionsViewStore}>
            <SubscriptionPlans premiumSubscriptionsViewStore={premiumSubscriptionsViewStore} />
            <PremiumContentList
                routeStore={premiumSubscriptionsViewStore.routeStore}
                premiumSubscriptionsViewStore={premiumSubscriptionsViewStore}
            />
            <DeviceLimitInfoModal modalParams={premiumSubscriptionsViewStore.deviceLimitInfoModal} />
        </MrbPreviewPage>
    );
}

const SubscriptionPlans = observer(function SubscriptionPlans({ premiumSubscriptionsViewStore }) {
    const {
        loaderStore,
        subscriptionPlans,
        setSelectedSubscriptionPlan,
        subscriptionExist,
        isFreeAccessType,
        openDeviceLimitInfoModal,
        rootStore: { premiumSubscriptionStore },
    } = premiumSubscriptionsViewStore;

    return (
        <div>
            <React.Fragment>
                {subscriptionPlans && subscriptionPlans.length > 0 && (
                    <div className="c-payment__list u-mar--bottom--lrg">
                        {map(subscriptionPlans, (subscriptionPlan) => {
                            if (
                                !isFreeAccessType &&
                                subscriptionPlan.slug === subscriptionPlansConstant.nakiRadioFree
                            ) {
                                return null;
                            }
                            return (
                                <SubscriptionPlanCard
                                    loaderStore={loaderStore}
                                    isPremiumTrialPeriodUsed={true} // premiumSubscriptionStore.isPremiumTrialPeriodUsed
                                    isInternalSubscriptionActive={premiumSubscriptionStore.isInternalSubscriptionActive}
                                    isUniSubscriptionDisabled={premiumSubscriptionStore.isUniSubscriptionDisabled}
                                    userAccessType={premiumSubscriptionStore.nakiRadioUserAccessType}
                                    subscriptionPlan={subscriptionPlan}
                                    isSubscriptionBundleActive={premiumSubscriptionStore.isSubscriptionBundleActive}
                                    subscription={subscriptionPlan.subscription}
                                    subscriptionExist={subscriptionExist}
                                    key={subscriptionPlan.id}
                                    onClickExploreContent={setSelectedSubscriptionPlan}
                                    onOpenDeviceLimitInfoModal={openDeviceLimitInfoModal}
                                />
                            );
                        })}
                    </div>
                )}
            </React.Fragment>
        </div>
    );
});

PremiumSubscriptionsTemplate.propTypes = {
    premiumSubscriptionsViewStore: PropTypes.object.isRequired,
};

export default defaultTemplate(PremiumSubscriptionsTemplate);
